import React from "react";

function VisitSummaryContentHeading({ text }) {
  return <div className="text-2xl font-medium text-black">{text}</div>;
}

export default VisitSummaryContentHeading;
